import React from 'react';
import { Navigate, Route } from 'react-router';
import { Routes } from 'react-router-dom';
import NotFoundPage from './base/errors/components/NotFoundPage';
import AccessDeniedPage from './base/errors/components/AccessDeniedPage';
import ManageSpaces from './admin/spaces/containers/ManageSpaces';
import Admin from './admin/Admin';
import ManageTags from './admin/tags/containers/ManageTags';
import { MainDashboard } from './dashboard';
import ManageRoles from './admin/roles/containers/ManageRoles';
import ManageUsers from './admin/users/containers/ManageUsers';
import ManagePermissions from './admin/permissions/containers/ManagePermissions';
import Permissions from './admin/permissions/components/Permissions';
import { ContactsPage } from './contacts';
import ManageDefaultDashboards from './admin/defaultDashboards/containers/ManageDefaultDashboards';
import SpaceRoutes from './spaces/containers/SpaceRoutes';
import MySpaces from './spaces/components/MySpaces';
import ManageMailingLists from './admin/mailingLists/containers/ManageMailingLists';
import ManageOfflineDocumentsPage from './offline/containers/ManageOfflineDocumentsPage';
import OfflineDocumentsPage from './offline/containers/OfflineDocumentsPage';
import Editor from './editor/Editor';
import GlobalPermissions from './admin/globalPermissions/GlobalPermissions';

const AppRoutes = () => (
  <Routes>
    <Route index element={<Navigate to="/dashboard" />} />
    <Route path="/dashboard" element={<MainDashboard />} />
    <Route path="/spaces" element={<MySpaces />} />
    <Route path="/spaces/*" element={<SpaceRoutes />} />
    <Route path="/contacts" element={<ContactsPage />} />
    <Route path="/admin/users" element={<ManageUsers />} />
    <Route path="/admin/roles" element={<ManageRoles />} />
    <Route path="/admin/permissions/:roleId" element={<ManagePermissions />} />
    <Route path="/admin/global-permissions" element={<GlobalPermissions />} />
    <Route path="/admin/permissions" element={<Permissions />} />
    <Route path="/admin/default-dashboards" element={<ManageDefaultDashboards />} />
    <Route path="/admin/spaces" element={<ManageSpaces />} />
    <Route path="/admin/tags" element={<ManageTags />} />
    <Route path="/admin/mailing-lists" element={<ManageMailingLists />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="/offline/test" element={<OfflineDocumentsPage />} />
    <Route path="/offline" element={<ManageOfflineDocumentsPage />} />
    <Route path="/403" element={<AccessDeniedPage />} />
    <Route path="/404" element={<NotFoundPage />} />
    <Route path="/editor" element={<Editor />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRoutes;
